import { useState, useEffect } from "react";

export type NetworkSpeed = "fast" | "slow" | "offline";

export interface NetworkStatus {
  isOnline: boolean;
  speed: NetworkSpeed;
  effectiveType: string;
  rtt: number;
  downlink: number;
}

function getNetworkStatus(): NetworkStatus {
  const conn =
    (navigator as any).connection ||
    (navigator as any).mozConnection ||
    (navigator as any).webkitConnection;

  const effectiveType: string = conn?.effectiveType || "4g";
  const rtt: number = conn?.rtt ?? 0;
  const downlink: number = conn?.downlink ?? 10;

  const speed: NetworkSpeed = !navigator.onLine
    ? "offline"
    : effectiveType === "slow-2g" || effectiveType === "2g" || rtt > 500
    ? "slow"
    : "fast";

  return { isOnline: navigator.onLine, speed, effectiveType, rtt, downlink };
}

export function useNetworkStatus(): NetworkStatus {
  const [status, setStatus] = useState<NetworkStatus>(getNetworkStatus);

  useEffect(() => {
    const update = () => setStatus(getNetworkStatus());

    window.addEventListener("online", update);
    window.addEventListener("offline", update);

    const conn = (navigator as any).connection;
    conn?.addEventListener("change", update);

    return () => {
      window.removeEventListener("online", update);
      window.removeEventListener("offline", update);
      conn?.removeEventListener("change", update);
    };
  }, []);

  return status;
}
